import { useState } from 'react';

import { OperationRefModel } from '../../Models/DomainServiceModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import { OperationInputDialog } from './OperationInputDialog';

type OperationInputProps = {
	operationRef: OperationRefModel | undefined;
	onOperationRefChange: (operationRef: OperationRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function OperationInput({ operationRef, onOperationRefChange, isEditable = true }: OperationInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={operationRef} />;
	}

	return (
		<GenericPropertyInput value={operationRef} onValueChange={onOperationRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={operationRef} />
			{open && <OperationInputDialog open={open} setOpen={setOpen} operationRef={operationRef} onOperationRefChange={onOperationRefChange} />}
		</GenericPropertyInput>
	);
}
